export const TESTNET_CHAINS = {
    lensChain: {
        name: "Lens Chain Testnet",
        chainId: 37111,
        icon: "/lens-logo.png",
        token: {
            name: "Testnet Rise Your Future",
            symbol: "tRYF",
            decimals: 18,
            address: "0x7326D8584c6b891B2f4B194CDF5ba746dD0D4080",
            icon: "/ryf-token-logo.png"
        },
        nativeToken: {
            name: "Grass",
            symbol: "GRASS",
            decimals: 18,
        }
    },
    bsc: {
        name: "BSC Testnet",
        chainId: 97,
        icon: "/bsc-logo.png",
        token: {
            name: "Testnet Rise Your Future",
            symbol: "tRYF",
            decimals: 18,
            address: "0x296fEF759bD54328236b8877Dad24e7aB70a1BC4",
            icon: "/ryf-token-logo.png"
        },
        nativeToken: {
            name: "Testnet BNB",
            symbol: "tBNB",
            decimals: 18
        }
    },
}

export const MAINNET_CHAINS = {
    lensChain: {
        name: "Lens Chain",
        chainId: 232,
        icon: "/lens-logo.png",
        token: {
            name: "Rise Your Future",
            symbol: "RYF",
            decimals: 18,
            address: "0x93198F5e56443286b50Cf749dFb6A27f251aA630",
            icon: "/ryf-token-logo.png"
        },
        nativeToken: {
            name: "GHO",
            symbol: "GHO",
            decimals: 18
        }
    },
    bsc: {
        name: "BNB Smart Chain",
        chainId: 56,
        icon: "/bsc-logo.png",
        token: {
            name: "Rise Your Future",
            symbol: "RYF",
            decimals: 18,
            address: "0xF9965785630FFC1AE6F1D1EDB7339c1Fe4FAEaa5",
            icon: "/ryf-token-logo.png"
        },
        nativeToken: {
            name: "BNB",
            symbol: "BNB",
            decimals: 18
        },
        usdt: {
            name: "Tether USD",
            symbol: "USDT",
            address: "0x55d398326f99059fF775485246999027B3197955",
            decimals: 18,
            icon: "/usdt-icon.png"
        },
        vndc: {
            name: "VNDC Token",
            symbol: "VNDC",
            address: "0xDDE5B33a56f3F1C22e5a6bd8429E6ad508BFF24E",
            decimals: 0,
            icon: "/vndc-icon.png"
        }
    },
}